import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import MobileHeader from '@pcln/mobile-header'
import { Text } from 'pcln-design-system'
import BootstrapDataContext from '../../context/BootstrapDataContext'
import {
  ANALYTICS_CATEGORY_FLIGHTS,
  ANALYTICS_CATEGORY_PACKAGES
} from '../../constants/analytics'

const ANALYTICS_CATEGORY = {
  flights: ANALYTICS_CATEGORY_FLIGHTS,
  packages: ANALYTICS_CATEGORY_PACKAGES
}

const TAB_CHILDREN = [
  <Text fontSize={12} fontWeight="bold">
    HOTELS
  </Text>,
  <Text fontSize={12} fontWeight="bold" cap>
    FLIGHTS
  </Text>,
  <Text fontSize={12} fontWeight="bold" cap>
    BUNDLE + SAVE
  </Text>,
  <Text fontSize={12} fontWeight="bold" cap>
    CARS
  </Text>,
  <Text fontSize={12} fontWeight="bold" cap>
    CRUISES
  </Text>
]

const ITEMS = MobileHeader.items.map((item, index) => {
  return { ...item, child: TAB_CHILDREN[index] }
})

const MobileHeaderWrapper = ({ selectedProductName }) => {
  const { key = '' } = useContext(BootstrapDataContext)
  const category = ANALYTICS_CATEGORY[key]

  return (
    <MobileHeader
      analyticsCategory={category}
      items={ITEMS}
      selectedItem={selectedProductName}
    />
  )
}

MobileHeaderWrapper.propTypes = {
  selectedProductName: PropTypes.string.isRequired
}

export default MobileHeaderWrapper
